// components/StationTopology.js
// 站点主接线图（纯 SVG，无第三方依赖）：电网 → 断路器 → 变压器 → 交流母线，四条支路（光伏 / 储能 / 充电桩 / 负荷）
import React from 'react';

const DeviceBox = ({ cx, y, h = 40, name, value }) => (
  <g>
    <rect className="tpl-dev" x={cx - 46} y={y} width={92} height={h} rx={6} />
    <text className="tpl-nm" x={cx} y={y + 17} textAnchor="middle">{name}</text>
    <text className="tpl-val" x={cx} y={y + 32} textAnchor="middle">{value}</text>
  </g>
);

const StationTopology = () => (
  <div className="tpl-wrap">
    <svg className="tpl-svg" viewBox="0 0 640 306" role="img" aria-label="站点主接线图">
      {/* 交流母线 */}
      <line className="tpl-bus" x1="196" y1="150" x2="628" y2="150" />

      {/* 进线：电网 → 断路器 → 变压器 → 母线 */}
      <rect className="tpl-dev" x="12" y="128" width="72" height="44" rx="6" />
      <text className="tpl-nm" x="48" y="147" textAnchor="middle">电 网</text>
      <text className="tpl-val" x="48" y="163" textAnchor="middle">10 kV</text>

      <line className="tpl-flow" x1="84" y1="150" x2="110" y2="150" />
      <line className="tpl-qf" x1="114" y1="142" x2="126" y2="158" />
      <line className="tpl-flow" x1="128" y1="150" x2="146" y2="150" />

      <circle className="tpl-tr" cx="156" cy="150" r="10" />
      <circle className="tpl-tr" cx="172" cy="150" r="10" />
      <text className="tpl-nm" x="164" y="118" textAnchor="middle">变压器</text>
      <text className="tpl-val" x="164" y="132" textAnchor="middle">10/0.4 kV</text>

      <line className="tpl-flow" x1="182" y1="150" x2="196" y2="150" />

      {/* 支路一：光伏 */}
      <line className="tpl-flow" x1="250" y1="150" x2="250" y2="98" />
      <line className="tpl-qf" x1="244" y1="140" x2="256" y2="156" />
      <DeviceBox cx={250} y={58} name="光伏逆变器" value="312 kW" />
      <line className="tpl-flow" x1="250" y1="58" x2="250" y2="50" />
      <rect className="tpl-pv" x="222" y="16" width="56" height="34" rx="4" />
      <line className="tpl-pvline" x1="222" y1="27" x2="278" y2="27" />
      <line className="tpl-pvline" x1="222" y1="39" x2="278" y2="39" />
      <line className="tpl-pvline" x1="250" y1="16" x2="250" y2="50" />

      {/* 支路二：储能 */}
      <line className="tpl-flow" x1="358" y1="150" x2="358" y2="200" />
      <line className="tpl-qf" x1="352" y1="144" x2="364" y2="160" />
      <DeviceBox cx={358} y={200} name="PCS" value="250 kW" />
      <line className="tpl-flow" x1="358" y1="240" x2="358" y2="262" />
      <DeviceBox cx={358} y={262} h={38} name="电池簇" value="SOC 78%" />

      {/* 支路三：充电桩 */}
      <line className="tpl-flow" x1="466" y1="150" x2="466" y2="98" />
      <line className="tpl-qf" x1="460" y1="140" x2="472" y2="156" />
      <DeviceBox cx={466} y={58} name="充电桩" value="6 × 120 kW" />

      {/* 支路四：负荷 */}
      <line className="tpl-flow" x1="574" y1="150" x2="574" y2="200" />
      <line className="tpl-qf" x1="568" y1="144" x2="580" y2="160" />
      <DeviceBox cx={574} y={200} name="负荷" value="268 kW" />
    </svg>
  </div>
);

export default StationTopology;